import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Resets the scroll position on every route change so each page starts at the top.
 * When the URL carries a hash (e.g. "/#experiences"), it smooth-scrolls to that
 * section instead, after a short delay to let the target page render.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      const timer = window.setTimeout(() => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        } else {
          window.scrollTo({ top: 0, behavior: "smooth" });
        }
      }, 150);
      return () => window.clearTimeout(timer);
    }

    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname, hash]);

  return null;
}